module.exports = __webpack_public_path__ + "static/practice management-01-crop-u401002-6d72b4882521de0e8f455f7043a91ddd.png";